let url = `https://api.instagram.com/v1/tags/BRUTALSIMPLICITY/media/recent?count=5`

import { addImage, getData } from './data.js'
	
export function getInstagramData(accessKey = null) {
	let request = new XMLHttpRequest()
	
	request.open('GET', `${url}&${accessKey}`, true)

	request.onload = (err) => {
	  if (request.status >= 200 && request.status < 400) {
	    	let res = JSON.parse(request.responseText)

			res.data.forEach((item) => {
				addImage({ 'url' : item.images.standard_resolution.url, 'owner' : item.user.full_name, 'ownerLink' : item.user.username, 'approved' : false }, true)
			})

	    	if(!!res.pagination.next_url) {
	    		url = res.pagination.next_url
	    		getInstagramData()
	    	} else {
	    		getData('admin')
	    	}

	    } else {
			console.log('ERROR ', err.srcElement.responseText)
		}
	}
	request.onerror = (err) => {
	  console.log(err)
	}
	request.send()

}



// WEBPACK FOOTER //
// ./js/instagram.js